import React from 'react';
import { toast } from 'react-hot-toast';

import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalButtons from '../../components/Modal/ModalButtons';
import Button from '../../components/Button';

// Shown once, right after a user is created on a C2C with email off. The temp
// password can't be re-retrieved (only its hash is stored), so this dialog is the
// single opportunity to copy it and hand it over out-of-band.
const TempPasswordModal = ({ info, onClose }) => {
	const copy = async () => {
		try {
			await navigator.clipboard.writeText(info.tempPassword);
			toast.success('Temporary password copied.');
		} catch (e) {
			toast.error('Copy failed — select the password and copy it manually.');
		}
	};

	return (
		<Modal show={!!info}>
			<ModalHeading heading='Temporary password' subHeading='' onClose={onClose} />
			<div style={{ padding: '0 1.5rem 1rem', maxWidth: '34rem' }}>
				<p style={{ marginTop: 0 }}>
					Email is off, so <strong>{info?.username}</strong> was created with a one-time
					temporary password. Give it to the user over a trusted channel — it is shown{' '}
					<strong>once</strong> and cannot be retrieved later. They will be required to
					change it at first login.
				</p>
				<div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', flexWrap: 'wrap' }}>
					<code
						style={{
							padding: '0.6rem 0.9rem',
							background: 'rgba(127,127,127,0.15)',
							borderRadius: '0.4rem',
							fontSize: '1.05rem',
							letterSpacing: '0.02em',
							userSelect: 'all',
							wordBreak: 'break-all',
						}}
					>
						{info?.tempPassword}
					</code>
					<Button label='Copy' onClick={copy} />
				</div>
			</div>
			<ModalButtons cancelButtonLabel='Done' onCancel={onClose} />
		</Modal>
	);
};

export default TempPasswordModal;
